import React, { useEffect } from 'react';

import { Route, Switch, useLocation } from 'react-router-dom';

import useStorage from 'hooks/useStorage';
import { useAppDispatch } from 'redux/hooks';
import { getUserFullData } from 'redux/editProfile/userProfile.slices';
import { quizRoutes } from 'types/quiz';
import WithPermission from 'hooks/WithPermission';
import Dashboard from 'views/Dashboard/Dashboard';
import Chat from 'views/Chat/Chat';
import Grades from 'views/Grades/Grades';
import Attendance from 'views/Attendance/Attendance';
import Permissions from 'views/Permissions/Permissions';
import Marks from 'views/Marks/Marks';
import StudentGrades from 'views/Student/Grades/Grades';
import StudentAttendance from 'views/Student/Attendance/Attendance';
import Study from 'views/Study/Study';
import StudentQuiz from 'views/Student/Quiz/Quiz';
import TeacherQuiz from 'views/Teacher/Quiz/Quiz';
import NavigationDrawer from 'components/NavigationDrawer/NavigationDrawer';
import Header from 'components/Header/Header';
import LiveClass from 'views/LiveClass/LiveClass';
import RenderWithRole from 'hoc/renderWithRole';
import EditProfile from 'views/EditProfile/EditProfile';
import BottomNavigation from 'components/BottomNavigation/BottomNavigation';
import Events from 'views/Events/Events';
import DailyMessage from 'views/DailyMessage/DailyMessage';
import Debug from 'views/Debug/Debug';

import './User.scoped.scss';

const User: React.FC = () => {
  const [shortWidth, setShortWidth] = useStorage(false, 'main-menu-minimized');

  const location = useLocation();
  const dispatch = useAppDispatch();

  const firstPartOfPath = location.pathname.split('/')[1];

  useEffect(() => {
    dispatch(getUserFullData());
  }, []);

  const handleNavigationMinimazing = value => {
    setShortWidth(value);
  };

  return (
    <div className="user-layout">
      <div className={`${shortWidth && 'short'} navigation-drawer-layout`}>
        <NavigationDrawer isMinimized={shortWidth} onLayoutChange={handleNavigationMinimazing} />
      </div>
      <div className={`${shortWidth && 'short'} page-layout`}>
        <Header />
        <div
          id="root-route"
          className={`${shortWidth && 'short'} ${
            (location.pathname === '/chat' || firstPartOfPath === 'study') && 'no-scroll'
          } user-inner-layout`}
        >
          {RenderWithRole({
            teacher: (
              <Switch>
                <Route exact path="/" component={Dashboard} />
                <Route path="/chat" component={Chat} />
                <Route exact path="/marks" component={Marks} />
                <Route exact path="/permissions" component={Permissions} />
                <Route exact path="/permissions/roles" component={Permissions} />
                <Route exact path="/permissions/roles/new" component={Permissions} />
                <Route exact path="/permissions/roles/:id" component={Permissions} />
                <Route exact path="/permissions/users" component={Permissions} />
                <Route exact path="/permissions/users/:id" component={Permissions} />
                <Route exact path="/grades" component={Grades} />
                <Route exact path="/attendance" component={Attendance} />
                <Route exact path="/grades/preview" component={Grades} />
                <Route path="/live" component={LiveClass} />
                <Route path="/study" component={Study} />
                <Route path={quizRoutes.defaultPath} component={TeacherQuiz} />
                <Route path="/edit-profile" component={EditProfile} />
                <Route path="/events" component={Events} />
                <Route path="/daily-message" component={DailyMessage} />
                {process.env.NODE_ENV === 'development' && (
                  <Route path="/debug" component={Debug} />
                )}
              </Switch>
            ),
            student: (
              <Switch>
                <Route exact path="/" component={Dashboard} />
                <Route path="/chat" component={Chat} />
                <Route exact path="/grades" component={StudentGrades} />
                <Route exact path="/attendance" component={StudentAttendance} />
                <Route path="/live" component={LiveClass} />
                <Route path="/study" component={Study} />
                <Route path={quizRoutes.defaultPath} component={StudentQuiz} />
                <Route path="/edit-profile" component={EditProfile} />
              </Switch>
            ),
            parent: (
              <Switch>
                <Route exact path="/" component={Dashboard} />
                <WithPermission permissionRequired={'chat'}>
                  <Route path="/chat" component={Chat} />
                </WithPermission>
                <WithPermission permissionRequired={'grading'}>
                  <Route exact path="/grades" component={StudentGrades} />
                </WithPermission>
                <Route path="/study" component={Study} />
                <Route path="/edit-profile" component={EditProfile} />
              </Switch>
            ),
          })}
        </div>
      </div>
      <BottomNavigation />
    </div>
  );
};

export default User;
